module.exports = __webpack_public_path__ + "static/img/basic_operation01.fc58559.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/basic_operation01.png
// module id = WLD9
// module chunks = 1